import { ClaudeTemplate } from "../types";

/** Hivestack: DOOH (pantallas exteriores digitales) programático. */
export const hivestackTemplate: ClaudeTemplate = {
  id: "hivestack",
  tool: "Hivestack DSP",
  url: "https://www.hivestack.com/ (entra en la DSP con tu usuario; la URL de acceso puede variar)",
  hierarchy:
    "Advertiser → Campaign → Line items → Creatives (por resolución de pantalla)",
  idHint:
    "columna ID de la lista de campañas o el número que aparece en la URL al abrir la campaña",
  accountField: "hivestackAdvertiserIds",
  steps: `
### 1. Entrar en el advertiser (puede que ya estés dentro)
1. Abre la DSP de Hivestack. Si ya está abierta, sigue.
2. Entra en el **Advertiser** del cliente {{client}}. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscalo por nombre; si hay varios candidatos, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, créala:
   - Name: {{names.order}}
   - Fechas: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: {{goal.budget}}.
   - Moneda: {{goal.currency}} (si no coincide con la de la cuenta, pregunta).
3. Guarda sin activar.

### 3. Line item
1. Crea un line item dentro de la campaña:
   - Name: {{names.line}}
   - Budget: el de la campaña salvo que las notas indiquen otro reparto.
   - Bid / CPM: en torno a {{goal.netUnitCost}}.
   - Pacing: even.
2. Targeting:
   - Ubicación: {{target.geography}} (país {{goal.country}}). Si el briefing habla de ciudades, zonas o tipos de recinto (centros comerciales, transporte, calle…), selecciónalos; si solo dice país, pregunta si se quiere todo el inventario del país.
   - Tipos de pantalla / venue types y horarios (dayparting): lo que digan las notas ({{goal.notes}} / {{target.notes}}).
   - Audiencias (si las hay): {{target.audience}}.
   - Exclusiones: {{target.exclusions}}.
3. Guarda sin activar.

### 4. Creatives
1. Las pantallas DOOH piden resoluciones concretas. Revisa los enlaces del bloque "Creatividades" y sube cada pieza a las pantallas compatibles.
2. Si faltan resoluciones para parte del inventario elegido, dímelo (no reduzcas el inventario sin preguntar).
3. Las creatividades pasan por aprobación de los propietarios de las pantallas: es normal que queden pendientes.
`,
};
